import { render, staticRenderFns } from "./BlogPostsSidebarAds.vue?vue&type=template&id=ba3eb4da&scoped=true&"
var script = {}
import style0 from "./BlogPostsSidebarAds.vue?vue&type=style&index=0&id=ba3eb4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3eb4da",
  null
  
)

export default component.exports